import { useGetDashboardStatsQuery } from '@/features/admin/api/superAdminApi';
import { useListSessionsQuery } from '../../../api/sessionsApi';

export function useDashboardData(userId?: string, days: number = 1) {
  const { data: summaryData, isLoading: isSummaryLoading } = useGetDashboardStatsQuery({ days, user_id: userId });
  const { data: sessionsData, isLoading: isSessionsLoading } = useListSessionsQuery(
    { page: 1, limit: 5, user_id: userId, days },
    { skip: window.location.pathname.includes('super') || !!(JSON.parse(localStorage.getItem('admin_user') || '{}')?.role === 'SuperAdmin') } // SuperAdmins don't need sessions
  );

  return {
    summary: summaryData?.data,
    isSummaryLoading,
    recentSessions: sessionsData?.data?.data || [],
    isSessionsLoading,
    totalCalls: sessionsData?.data?.pagination?.total || 0,
  };
}
